import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import SearchBy from "components/SearchBy";
import { AddIcon } from "components/SVGs";
import { IFilterOption, IStyles } from "features/common/Interfaces";
import DeleteIcon from "components/SVGs/Delete";
import { FireBaseContext } from "contexts/FireBase";
import { useContext } from "react";

const customStyle: IStyles = {
  root: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "10px 0",
    width: "100%",
  },
  btn: {
    width: "160px",
  },
};

interface IToolBar {
  addLabel: string;
  addAction(): void;
  deleteLabel?: string;
  deleteAction?(): void;
  filterConfig: {
    getFilterType(type: { currentTarget: IFilterOption }): void;
    getSearchValue(value: string): void;
    selectedFilter: IFilterOption;
    filterTypes: IFilterOption[];
  };
  noData: boolean;
}

function ToolBar({
  addLabel,
  addAction,
  deleteLabel,
  deleteAction,
  filterConfig,
  noData = true,
}: IToolBar) {
  const { i18n } = useTranslation();
  const { logEvent } = useContext(FireBaseContext);

  return (
    <Typography component="div" sx={customStyle.root}>
      <Typography
        component="div"
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          "& > *": {
            margin: "0 2px",
          },
        }}
      >
        <Button
          label={addLabel}
          Icon={
            <AddIcon sx={{ background: "rgb(255 255 255)", margin: "0 5px" }} />
          }
          white
          styles={{
            ...customStyle.btn,
            justifyContent: i18n.dir() === "rtl" ? "right" : "left",
          }}
          action={addAction}
        />
        {deleteAction && deleteLabel ? (
          <Button
            label={deleteLabel}
            Icon={
              <DeleteIcon
                sx={{
                  background: "rgb(255 255 255)",
                  margin: "0 5px",
                  "& path": {
                    fill: "rgb(97, 194, 238)",
                  },
                }}
              />
            }
            white
            styles={{
              ...customStyle.btn,
              justifyContent: i18n.dir() === "rtl" ? "right" : "left",
            }}
            action={deleteAction}
          />
        ) : null}
      </Typography>
      {!noData ? (
        <div
          onClick={() => {
            const teacherSearchTypes = {
              Teacher: "By Name",
              Email: "By Email",
            };
            const studentSearchTypes = {
              Student: "By Name",
              StudentId: "By ID",
            };
            const isTeacherSearch = ["Teacher", "Email"].includes(
              filterConfig.selectedFilter.value
            );
            const searchTypes = isTeacherSearch
              ? teacherSearchTypes
              : studentSearchTypes;
            const searchEventName = isTeacherSearch
              ? "ClickOnSearchTeacher"
              : "ClickOnSearchStudent";
            logEvent(searchEventName, {
              Search_Type:
                searchTypes[
                  filterConfig.selectedFilter.value as keyof typeof searchTypes
                ],
            });
          }}
        >
          <SearchBy {...filterConfig} />
        </div>
      ) : null}
    </Typography>
  );
}

export default ToolBar;
